import apiClient from "./axios";

interface FeatureFlagsResponse {
  flags: Record<string, boolean>;
  /** False when the server could not reach Mixpanel — every flag is then `false`. */
  resolved: boolean;
}

/**
 * Resolve Mixpanel feature gates for the signed-in user through RAP's backend (RAP-668).
 *
 * The browser used to ask Mixpanel directly, so an ad blocker failed every gate closed and a
 * funder saw an empty portal. The server derives the targeting context (user, firm, user kind)
 * itself — nothing but the key list is sent.
 *
 * Never rejects. Every requested key is present in the result: a key the server did not answer
 * (unknown to it) and every key on a failed request resolve `false`, so a failed refresh
 * overwrites stale trues and the UI fails closed.
 */
export async function fetchFeatureFlags(keys: readonly string[]): Promise<Record<string, boolean>> {
  try {
    const { data } = await apiClient.get<FeatureFlagsResponse>("/feature-flags", {
      params: { keys: keys.join(",") },
    });
    return Object.fromEntries(keys.map((key) => [key, data.flags?.[key] === true]));
  } catch {
    return Object.fromEntries(keys.map((key) => [key, false]));
  }
}
